module.exports = __webpack_public_path__ + "img/blind_guide.fa7f8b48.png";